














































import { PropType, defineComponent, computed, ref, getCurrentInstance } from '@vue/composition-api';
import { SprintRecommendActionJson, Message, SprintRecommendData, SprintRiskRecommendItem } from '../../dataType';
import Card from './Card.vue';
import { useLocale } from '../../hooks/useLocale';
import { useSprintRiskRecommendMessage, useMessage } from '../../hooks/useMessage';
import { useMessageInteract } from '../../hooks/useMessageInteract';
import { resolveUrl } from '@zk/framework-vue';
import config from 'common-module/src/config';
export default defineComponent({
  components: {
    Card
  },
  props: {
    message: {
      type: Object as PropType<Message<SprintRecommendData>>,
      required: true
    }
  },
  setup(props) {
    const { t } = useLocale();
    const instance = getCurrentInstance()?.proxy!;
    const { addUserTextMessage, robotWaitWithAsyncOperation, sendMessageAndUpdateId } = useMessage();
    const { recommends, isCreateSprint, actionType } = useSprintRiskRecommendMessage(props.message);
    const { isDisabled } = useMessageInteract(props.message);

    const createSprintDisabled = ref<boolean>(false);

    const sprintHandlerBtn = computed(() =>{
      const sprintBtnText = {
        sprint_risk_start_sprint: t('backlog.start_label'),
        sprint_risk_enable_sprint: t('saas.robotChat.enableFeature'),
        sprint_risk_create_sprint: t('saas.robotChat.createSprint'),
        sprint_risk_recommend_sprint: t('saas.robotChat.tryBtn')
      } as any;
      return sprintBtnText[actionType.value];
    });
    const confirm = (params: SprintRecommendActionJson, sendText: string, event: Event) => {
      const actionParams = {
        id: props.message.content.base.id || 0,
        inputText: {
          text: sendText,
          push: true,
          save: true
        },
        actionType: actionType.value,
        actionJson: params
      };
      let msg: Message<any> | null = null;
      if (sendText) {
        msg = addUserTextMessage(sendText);
      }
      robotWaitWithAsyncOperation(() => sendMessageAndUpdateId(msg, 'confirm', actionParams, {
        event: event,
        intent: props.message.content.intent,
        parabolaAnimation: true
      }));
      const Intent_Type = actionType.value === 'sprint_risk_start_sprint' ? '开始迭代' : actionType.value === 'sprint_risk_enable_sprint' ? '开启迭代' : '';
      Intent_Type && instance.$track.send('WebIM_SendIntent', {
        Send_Type: '反问推荐',
        Intent_Type:  Intent_Type
      }, true);
    };
    const sprintHandle = (recommend: SprintRiskRecommendItem, event: Event) => {
      const currentContent = props.message.content;
      const sprintParamsHandle = {
        //开始迭代
        sprint_risk_start_sprint: {
          params: {
            id: currentContent.base.id,
            sprintId: recommend.sprintId,
            projectId: recommend.projectId,
            params : {
              type: 'sprint',
              sprint: recommend.params?.sprint
            },
            placeholderContent: currentContent.base.placeholderContent
          },
          text:t('saas.robotChat.startSprint', { sprint: recommend.sprintName })
        },
        // 启用迭代
        sprint_risk_enable_sprint:{
          params: {
            id: currentContent.base.id,
            sprintId: recommend.sprintId,
            projectId: recommend.projectId
          },
          text:t('saas.robotChat.enableSprint', {
            sprint: recommend.sprintName,
            project: recommend.projectName
          })
        },
        // 开始迭代之后的推荐迭代
        sprint_risk_recommend_sprint:{
          params: {
            id: currentContent.base.id,
            intentCode: currentContent.intent,
            params : {
              ...recommend.params
            },
            source: currentContent.base.source,
            placeholderContent: currentContent.base.placeholderContent
          },
          text: t('saas.robotChat.recommendSprint', { sprint:recommend.label })
        }
      } as any;
      confirm(sprintParamsHandle[actionType.value].params, sprintParamsHandle[actionType.value].text, event);
    };
    // 创建迭代
    const toCreateSprint = () => {
      window.open(resolveUrl(config.VUE_APP_PMS_URL + '/backlog/list'), '_blank');
      createSprintDisabled.value = true;
    };
    return {
      t,
      recommends,
      isCreateSprint,
      isDisabled,
      sprintHandle,
      toCreateSprint,
      sprintHandlerBtn,
      createSprintDisabled
    };
  }
});
